// Static site content for Runner Trade Park Limited (RTPL)

export const COMPANY = {
  name: "Runner Trade Park Limited",
  short: "RTPL",
  tagline: "Beacon of trust and distinction.",
  established: "2018",
  address: "138/1 Tejgaon Industrial Area, Dhaka-1208, Bangladesh",
  phone: "+880 1700-000000",
  email: "info@rtplbd.com",
  intro:
    "Pioneering automotive excellence, Runner Trade Park Limited (RTPL), established in 2018, is the exclusive distributor of Eurogrip tyres and a trusted distributor of Bajaj lubricants for both two-wheelers (2W) and three-wheelers (3W) across Bangladesh.",
};

export const STATS = [
  { value: "2018", label: "Established" },
  { value: "64", label: "Districts Covered" },
  { value: "260+", label: "Dealer Network" },
  { value: "30+", label: "Product Lines" },
];

export const MISSION_VISION = {
  vision: [
    "We will establish RUNNER as a trusted brand through satisfying customers' needs, offering desired products & services at an affordable price.",
  ],
  mission: [
    "Our Mission is to establish our brand image by meeting customer requirements through environment-friendly technology and taking care of the return on investment of stakeholders.",
    "We will materialize our vision with effective and efficient human resources using a lean manufacturing process with high productivity.",
    "We will exceed customers' perceived value to make this world a better living.",
  ],
};

export const SERVICES = [
  { icon: "clock", title: "24/7 Service", desc: "Round-the-clock support so you're never stranded, day or night." },
  { icon: "timer", title: "120 Minutes Promise", desc: "Fast turnaround — we aim to get you back on the road within 120 minutes." },
  { icon: "shield-check", title: "6 Months Parts Warranty", desc: "Genuine parts backed by a reassuring six-month warranty." },
  { icon: "network", title: "Service & Parts Network", desc: "An extensive service and parts network spanning all of Bangladesh." },
  { icon: "truck", title: "Mobile Service Team", desc: "On-demand mobile technicians that come to you wherever you are." },
  { icon: "heart-pulse", title: "Health Checkup Campaigns", desc: "Regular vehicle health checkup campaigns to keep your ride in top shape." },
];

export const REVIEWS = [
  {
    name: "Mohammad Shihab Hossain",
    location: "Gafargaon, Mymensingh",
    rating: 5,
    text: "I have been using it for 1 year and 2 months. The load capacity is very good, the vehicle is comfortable, and I've found its engine capacity to be excellent.",
  },
  {
    name: "Rakibul Islam",
    location: "Chattogram",
    rating: 5,
    text: "Genuine Eurogrip tyres with great grip in the monsoon. RTPL's dealer support has been reliable and quick every time.",
  },
  {
    name: "Abdul Karim",
    location: "Rajshahi",
    rating: 5,
    text: "As a dealer, working with Runner Trade Park has been smooth — authentic products, fair pricing and timely deliveries.",
  },
];

export const GROUP_STRENGTH = [
  {
    title: "Nationwide Distribution",
    desc: "A robust supply chain reaching every corner of Bangladesh with timely deliveries.",
    icon: "truck",
  },
  {
    title: "Exclusive Tyre Distributor",
    desc: "Exclusive distributor of Eurogrip motorcycle tyres, complemented by Bajaj One Club (Gulf Dts), for the 2W and 3W segments.",
    icon: "badge-check",
  },
  {
    title: "Rigorous Quality Control",
    desc: "Every product meets and exceeds stringent industry benchmarks for reliability.",
    icon: "shield-check",
  },
  {
    title: "Customer-Centric Ethos",
    desc: "Lasting relationships built on impeccable service and competitive pricing.",
    icon: "handshake",
  },
];

export const TEAM = [
  {
    name: "Hafizur Rahman Khan",
    role: "Chairman",
    image: "/team-chairman.png",
    bio: "A visionary leader whose decades of experience and integrity have shaped RTPL into a beacon of trust in Bangladesh's automotive distribution industry.",
  },
  {
    name: "Rudaba Tazin",
    role: "CEO & Managing Director",
    image: "/team-md.png",
    bio: "Driving RTPL's growth with a customer-first vision, forging strong partnerships with world-class brands and expanding our nationwide reach.",
  },
];

export const BRANDS = [
  {
    name: "Eurogrip",
    tag: "The Bike Tyre Specialist",
    logo: "/content/brands/eurogrip.png",
    desc: "As the exclusive distributor in Bangladesh, we bring the complete range of Eurogrip ATT tubeless and tube-type motorcycle tyres — engineered for grip, durability and control.",
  },
  {
    name: "Bajaj",
    tag: "Genuine DTS-i Engine Oils",
    logo: "/content/brands/gulf.png",
    desc: "Distributing genuine Bajaj DTS-i engine oils, engineered specifically for Bajaj two-wheelers and three-wheelers for optimal engine protection and performance.",
  },
  {
    name: "ENOC",
    tag: "Premium Lubricants",
    logo: "/content/brands/enoc.png",
    desc: "ENOC (Emirates National Oil Company) — premium automotive lubricants engineered for superior performance and engine protection, now part of our growing portfolio.",
  },
];

export const REGIONS = [
  { name: "Dhaka Division", dealers: "120+" },
  { name: "Chattogram Division", dealers: "95+" },
  { name: "Rajshahi Division", dealers: "70+" },
  { name: "Khulna Division", dealers: "60+" },
  { name: "Sylhet Division", dealers: "45+" },
  { name: "Rangpur Division", dealers: "55+" },
  { name: "Barishal Division", dealers: "35+" },
  { name: "Mymensingh Division", dealers: "30+" },
];

// Dealer map pins — placeholder coordinates. Will be configured from the backend later.
// type: "dealership" (blue) or "retail" (red)
export const DEALER_LOCATIONS = [
  { name: "Dhaka", region: "Dhaka Division", position: [23.8103, 90.4125], dealers: "40+", type: "dealership" },
  { name: "Gazipur", region: "Dhaka Division", position: [23.9999, 90.4203], dealers: "18+", type: "retail" },
  { name: "Chattogram", region: "Chattogram Division", position: [22.3569, 91.7832], dealers: "35+", type: "dealership" },
  { name: "Cumilla", region: "Chattogram Division", position: [23.4607, 91.1809], dealers: "16+", type: "retail" },
  { name: "Cox's Bazar", region: "Chattogram Division", position: [21.4272, 92.0058], dealers: "9+", type: "retail" },
  { name: "Rajshahi", region: "Rajshahi Division", position: [24.3745, 88.6042], dealers: "22+", type: "dealership" },
  { name: "Bogura", region: "Rajshahi Division", position: [24.8465, 89.3773], dealers: "14+", type: "retail" },
  { name: "Khulna", region: "Khulna Division", position: [22.8456, 89.5403], dealers: "20+", type: "dealership" },
  { name: "Jashore", region: "Khulna Division", position: [23.1697, 89.2137], dealers: "12+", type: "retail" },
  { name: "Sylhet", region: "Sylhet Division", position: [24.8949, 91.8687], dealers: "18+", type: "dealership" },
  { name: "Rangpur", region: "Rangpur Division", position: [25.7439, 89.2752], dealers: "17+", type: "dealership" },
  { name: "Dinajpur", region: "Rangpur Division", position: [25.6217, 88.6354], dealers: "10+", type: "retail" },
  { name: "Barishal", region: "Barishal Division", position: [22.7010, 90.3535], dealers: "13+", type: "retail" },
  { name: "Mymensingh", region: "Mymensingh Division", position: [24.7471, 90.4203], dealers: "11+", type: "dealership" },
];

// Homepage offer pop-up (static for now; will be admin-managed later)
export const OFFER = {
  badge: "Limited Time Offer",
  title: "Genuine Eurogrip Tyres — Now In Stock",
  description:
    "Grip the road with confidence. Explore our complete range of authentic Eurogrip motorcycle tyres, available through our nationwide dealer network at unbeatable value.",
  image: "/content/products/tyre-11.jpg",
  ctaLabel: "Purchase Now",
  ctaCategory: "Interested to Purchase",
};

export const HERO_IMAGE = "/hero-workshop.jpg";
export const MAP_IMAGE =
  "https://images.unsplash.com/photo-1633788989414-8a8d43ff985e?auto=format&fit=crop&w=1600&q=80";
export const ABOUT_IMAGE = "/about-warehouse.jpg";
